import script from "./CustomDashboardTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardTableLoader.vue?vue&type=style&index=0&id=12945b46&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12945b46"]])

export default __exports__